import { Component, OnInit, ElementRef } from '@angular/core';

declare const Shapes: any;
declare const Rellax: any;

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit {

  constructor(
    private el:ElementRef
  ) { }
  
  drawBackground(): void {
    let AngularEl = this.el.nativeElement;
    new Shapes(this.el.nativeElement.querySelector("#background"),{ 
    count: 250,
    img: ['shape_0_1.svg','shape_0_2.svg','shape_0_3.svg','shape_0_8.svg','shape_1_1.svg','shape_1_2.svg', 'shape_1_3.svg','shape_1_8.svg','shape_2_1.svg','shape_2_2.svg','shape_2_3.svg','shape_2_8.svg','shape_3_1.svg','shape_3_2.svg','shape_3_3.svg','shape_3_8.svg'],
    top: {
      min: -17,
      max: 91.5
    }, left: {
      min: -17,
      max: 91.5
    }, rellax: false },function(){
      
      /*this.RellaxInstance = new Rellax(AngularEl.querySelector('#background').querySelector('.rellax'),{
        wrapper: AngularEl
      });
      this.RellaxInstance.elems = AngularEl.querySelector('#background').querySelectorAll('.rellax'); / Rellax force array of nodes
      this.RellaxInstance.refresh();*/
      
    });
  }

  ngOnInit(): void {
    this.drawBackground();
  }

}
